// eslint-disable-next-line no-shadow
enum MODULE_TO_PAGE_MAP {
  PLANNER_HOME = 'scenario_home',
  PLANNER = 'planner',
  INNOVATION = 'innovation',
  RENOVATION = 'renovation',
  PRICING = 'pricing',
  DELIST = 'delist',
  SUMMARY = 'summary',
  POTENTIAL_RISK = 'potentialrisk',
  SCENARIO_COMPARE = 'scenariocompare',
  SIMPLIFICATION = 'simplification',
  COGS = 'kpi_update'
}

export default MODULE_TO_PAGE_MAP;
